// extracted by mini-css-extract-plugin
module.exports = {"CancelButtonWrapper":"DealCancelButton_CancelButtonWrapper__fCLT0","CancelButton":"DealCancelButton_CancelButton__ZreAP"};